import dayjs from "dayjs";
import { notification } from "antd";
import {
   Functions,
   REGEX,
   applyReplacements
} from "../../../../../../../helpers/constraintParsers";
import { getForeignInputNames } from "../helpers/getForeignInputNames";
import useInputValuesByName from "./useInputValueByName";

const useEvaluateConstraint = (constraint, value, meta = []) => {
   const trimmedConstraint = constraint?.trim();
   const inputNames = getForeignInputNames(trimmedConstraint);
   const relatedInputs = useInputValuesByName(inputNames, {
      isJoin: REGEX.join.test(trimmedConstraint)
   });

   // value 0 is a valid value for a number input and should not be considered as false
   if (!trimmedConstraint || !(value === 0 ? true : value)) {
      return null;
   }

   const parsedConstraint = applyReplacements(trimmedConstraint);

   try {
      const isDateConstraint = /\b(today|now)\s*\(/.test(parsedConstraint);

      if (
         isDateConstraint &&
         value &&
         typeof value === "object" &&
         !(Object.getPrototypeOf(value) === dayjs().constructor.prototype)
      ) {
         value = dayjs(value.$d.$d ?? value);
      }
      // eslint-disable-next-line no-new-func
      const evaluate = new Function(
         "value",
         ...Object.keys(Functions),
         "relatedInputs",
         "meta",
         `return ${parsedConstraint};`
      );

      const res = evaluate(value, ...Object.values(Functions), relatedInputs, meta);
      console.log("🚀 ~ evaluateConstraint ~ parsedConstraint", {
         constraint: trimmedConstraint,
         parsedConstraint,
         value,
         relatedInputs,
         res
      });
      return res;
   } catch (e) {
      notification.warning({
         message: "Error evaluating xlsform fields",
         description:
            "Please check if the syntax is correct. If you believe this is an error, please contact your administrator."
      });
      console.log(
         "Error evaluating constraint. please check if the constraint syntax is correct. -- " + e
      );
   }
};

export default useEvaluateConstraint;
